import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { isSafeUrlMatch, withUnit } from '../utils/urlMatcherUtils.ts';

const KEY_PATTERN = /key=([^&]+)/;

const DEFAULT_WIDTH = '720px';
const DEFAULT_HEIGHT = '360px';

const matchOldSpreadsheetUrl = (url: string): string | null => {
	const match = KEY_PATTERN.exec(url);
	if (!match) {
		return null;
	}
	return `//docs.google.com/spreadsheet/pub?key=${match[1]}&output=html&widget=true&element=true&gid=0`;
};

const matchNewSpreadsheetUrl = (url: string): string | null => {
	if (!url.endsWith('/pubhtml')) {
		return null;
	}
	return `${url}?widget=true&headers=false&chrome=false`;
};

export const matchGoogleSpreadsheets: ProviderMatcher = (url, params) => {
	if (
		!isSafeUrlMatch(url, 'spreadsheets.google.com', '') &&
		!isSafeUrlMatch(url, 'docs.google.com', '/spreadsheet')
	) {
		return null;
	}
	const embedUrl = matchOldSpreadsheetUrl(url) ?? matchNewSpreadsheetUrl(url);
	if (!embedUrl) {
		return null;
	}
	return {
		kind: 'iframe',
		provider: 'Google Sheets',
		embedUrl,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
